const isHolidaySeason = () => {
    const d = new Date()
    return d.getMonth() === 11 && d.getDate() <= 26
}

export default isHolidaySeason